import { Button, StatusMessage } from '@krp/ui-kit'
import type { QueryView } from '@krp/client-runtime'

/**
 * Не-«готовые» состояния запроса одинаково во всех окнах фичи: загрузка,
 * пусто, нет входа, нет доступа, недоступно, ошибка. Текст сервера —
 * дословно (ADR-8), корреляция — для отчёта.
 */
export function QueryState({
  query,
  emptyText,
  onRetry,
}: {
  query: QueryView
  emptyText: string
  onRetry: () => void
}) {
  const meta =
    query.error?.correlationId !== null && query.error !== null
      ? `Код: ${query.error.code} · запрос ${query.error.correlationId}`
      : undefined
  const retry = (
    <Button variant="secondary" onClick={onRetry} actionId="common.retry">
      Повторить
    </Button>
  )
  switch (query.status) {
    case 'idle':
    case 'loading':
      return <StatusMessage kind="loading" title="Загрузка…" />
    case 'empty':
      return <StatusMessage kind="empty" title={emptyText} />
    case 'unauthorized':
      return <StatusMessage kind="unauthorized" title="Сессия завершена" text="Войдите снова, чтобы продолжить." />
    case 'forbidden':
      return (
        <StatusMessage kind="forbidden" title="Нет доступа" text={query.error?.message} {...(meta ? { meta } : {})} />
      )
    case 'unavailable':
      return (
        <StatusMessage
          kind="unavailable"
          title="Служба недоступна"
          text={query.error?.message}
          {...(meta ? { meta } : {})}
          action={retry}
        />
      )
    case 'error':
      return (
        <StatusMessage
          kind="error"
          title="Ошибка"
          text={query.error?.message}
          {...(meta ? { meta } : {})}
          action={retry}
        />
      )
    case 'ready':
      return null
  }
}
